import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { formatDate } from 'helpers'
const disableView = ['estimatedDate', 'trackingNumber', 'trackingUrl'];

const Simple = ({ name, id, category, props, isFormatNumber, isPostfix }) => {
    const value = !category ? props[id] : props[category] && props[category][id];
    const additionalInfo = isPostfix && isFormatNumber ? props.currency : '';
    const itemClass = cx('item', {
        item__summary: id === 'grandtotal',
    });
    const itemValueClass = cx('item__value', {
        'item__value--right': category === 'summary',
    });

    const renderValue = () => {
        switch (id) {
            case 'estimatedDate':
                return (
                    value && <React.Fragment>
                        {formatDate(value)}
                        <span className="text-muted">Data dostawy zależy od produktu z najdłuższym czasem wysyłki oraz wybranego sposobu dostawy.</span>
                    </React.Fragment>
                )
            case 'trackingUrl':
                return false;
            case 'trackingNumber':
                return (
                    value && (
                        <div>
                            <a href={props['orderStatus']['trackingUrl']} rel="noopener noreferrer" target="_blank">{value}</a>
                            <a href={props['orderStatus']['trackingUrl']} rel="noopener noreferrer" className="item__link" target="_blank">
                                <span>Śledź przesyłkę</span>»
                            </a>
                        </div>
                    )
                );
            case 'orderStatus':
                return props[id].currentStatusLabel;
            case 'sendDate':
                const { sendDate } = props['orderStatus'];
                return sendDate && formatDate(sendDate);
            case 'created':
                return value && formatDate(value)

            default:
                return `${isFormatNumber ? Number(value).toFixed(2) : value} ${additionalInfo}`;
        }
    };

    let checkIfAllowedView = !(props['orderStatus'].canceled && disableView.includes(id));

    if ((typeof value === 'string' && value.length === 0) || id === 'trackingUrl') {
        checkIfAllowedView = false;
    }

    if (id === 'sendDate' && !props['orderStatus'].sendDate) {
        checkIfAllowedView = false;
    }

    return checkIfAllowedView ? (
        <li className={itemClass} id={id}>
            <span className="item__label">{name}</span>
            <div className={itemValueClass}>{renderValue()}</div>
        </li>
    ) : (
            ''
        );
};

Simple.propTypes = {
    name: PropTypes.string,
    id: PropTypes.string,
    category: PropTypes.string,
    props: PropTypes.object,
    isFormatNumber: PropTypes.bool,
    isPostfix: PropTypes.bool,
};

export default Simple;
